import type { FeedbackAccuracyData } from "@repo/app-types/helpers/feedbackHelpers";
import {
  IconCircleCheck,
  IconCircleX,
  IconExclamationCircle,
} from "@tabler/icons-react";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

interface FeedbackAccuracySummaryProps {
  accuracyData: FeedbackAccuracyData;
  className?: string;
}

export const FeedbackAccuracySummary: FC<FeedbackAccuracySummaryProps> = ({
  accuracyData,
  className = "",
}) => {
  if (accuracyData.total === 0) return null;

  return (
    <div className={twMerge("flex items-center gap-4", className)}>
      {accuracyData.correct > 0 && (
        <div className="flex items-center gap-2">
          <IconCircleCheck className="size-5 text-success" />
          <span className="text-sm font-medium">
            {accuracyData.correct} correct
          </span>
        </div>
      )}
      {accuracyData.close > 0 && (
        <div className="flex items-center gap-2">
          <IconExclamationCircle className="size-5 text-yellow-600" />
          <span className="text-sm font-medium">
            {accuracyData.close} close
          </span>
        </div>
      )}
      {accuracyData.incorrect > 0 && (
        <div className="flex items-center gap-2">
          <IconCircleX className="size-5 text-destructive" />
          <span className="text-sm font-medium">
            {accuracyData.incorrect} incorrect
          </span>
        </div>
      )}
    </div>
  );
};
